<template>
  <div class="customerPaymentManager">
    <!-- 页面头部 -->
    <div class="page-header">
      <div class="header-info">
        <div class="page-title">客户账号管理</div>
        <div class="page-desc">管理各合同下的银行账号信息，支持多账号维护。</div>
      </div>
      <div class="header-search">
        <el-input
          v-model="searchKeyword"
          placeholder="请输入合同号或客户名称查询"
          prefix-icon="el-icon-search"
          size="small"
          style="width: 260px"
          clearable
          @keyup.enter.native="handleSearch"
        ></el-input>
        <el-button type="danger" size="small" style="margin-left: 8px" @click="handleSearch">查询</el-button>
      </div>
    </div>

    <!-- 合同卡片列表 -->
    <div class="card-grid" v-loading="loading">
      <div v-if="filteredGroups.length === 0 && !loading" class="empty-state">
        暂无数据
      </div>
      <div
        v-for="group in filteredGroups"
        :key="group.customerCode"
        class="contract-card"
      >
        <!-- 合同信息头部 -->
        <div class="contract-header">
          <span class="contract-code">{{ group.customerCode }}</span>
          <div class="contract-tags">
            <el-tag size="mini" class="tag-type" disable-transitions>
              {{ getContractTypeLabel(group.contractType) }}
            </el-tag>
            <el-tag size="mini" :type="group.contractStatus == 1 ? 'success' : 'info'" disable-transitions>
              {{ group.contractStatus == 1 ? '已生效' : '已失效' }}
            </el-tag>
          </div>
        </div>
        <div class="customer-name">
          <i class="el-icon-s-custom"></i>
          {{ group.customerName }}
        </div>

        <!-- 银行账号列表 -->
        <div class="bank-section">
          <div class="bank-section-header">
            <span>关联银行账号 ({{ group.payments.length }})</span>
            <el-button v-if="isSuperAdmin" type="text" class="add-link" @click="openAddDialog(group)">+ 新增</el-button>
          </div>
          <div v-if="group.payments.length === 0" class="empty-bank">
            暂无关联账号，请点击右上角新增
          </div>
          <div
            v-for="payment in group.payments"
            :key="payment.id"
            class="bank-item"
          >
            <div class="bank-icon-wrap">
              <i class="el-icon-bank-card bank-icon"></i>
            </div>
            <div class="bank-info">
              <div class="bank-name-num">
                <!-- {{ payment.openingBank }}<span class="account-num">{{ maskAccount(payment.accountNumber) }}</span> -->
                {{ payment.openingBank }}<span class="account-num">{{ payment.accountNumber }}</span>
              </div>
              <div class="bank-payer">
                {{ payment.payer }}
              </div>
            </div>
            <div class="bank-actions"  v-if="isSuperAdmin">
              <i class="el-icon-edit action-icon" @click="openEditDialog(group, payment)"></i>
              <i class="el-icon-delete action-icon delete-icon" @click="handleDelete(payment)"></i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 新增/修改弹窗 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="460px"
      top="20vh"
      :close-on-click-modal="false"
      @close="resetForm"
    >
      <el-form :model="form" :rules="rules" ref="paymentForm" label-width="90px" size="small">
        <el-form-item label="账号类型" prop="paymentType">
          <el-select v-model="form.paymentType" placeholder="请选择账号类型" style="width: 100%">
            <el-option label="个人" value="person"></el-option>
            <el-option label="企业" value="enterprise"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开户名" prop="payer">
          <el-input v-model="form.payer" placeholder="请输入开户名" clearable></el-input>
        </el-form-item>
        <el-form-item label="开户行" prop="openingBank">
          <el-input v-model="form.openingBank" placeholder="请输入开户行" clearable></el-input>
        </el-form-item>
        <el-form-item label="开户账号" prop="accountNumber">
          <el-input v-model="form.accountNumber" placeholder="请输入开户账号" clearable></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="handleSubmit" size="small" :loading="submitting">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import API from '../../../api/setTing'
const api = new API()

const CONTRACT_TYPE_MAP = { LTT: '零担快递', FV: '整车', CBS: '跨境', SC: '仓储' }

export default {
  data() {
    return {
      loading: false,
      submitting: false,
      searchKeyword: '',
      appliedKeyword: '',
      allData: [],
      dialogVisible: false,
      dialogTitle: '新增银行账号',
      isEdit: false,
      currentGroup: null,
      form: {
        id: null,
        paymentType: '',
        payer: '',
        accountNumber: '',
        openingBank: ''
      },
      rules: {
        paymentType: [{ required: true, message: '请选择账号类型', trigger: 'change' }],
        payer: [{ required: true, message: '请输入开户名', trigger: 'blur' }],
        accountNumber: [{ required: true, message: '请输入开户账号', trigger: 'blur' }],
        openingBank: [{ required: true, message: '请输入开户行', trigger: 'blur' }]
      }
    }
  },
  computed: {
    groupedData() {
      const map = {}
      this.allData.forEach(item => {
        const key = item.customerCode+'_'+item.contractType
        if (!map[key]) {
          map[key] = {
            customerCode: item.customerCode,
            customerName: item.customerName,
            contractType: item.contractType,
            contractStatus: item.contractStatus,
            contractId:item.contractId,
            payments: []
          }
        }
        if (item.payInfoList && item.payInfoList.length > 0) {
          item.payInfoList.forEach(payment => {
            map[key].payments.push({
              ...payment
            })
          })
        }
      })
      return Object.values(map)
    },
    isSuperAdmin(){
      const role = window.localStorage.getItem('role')
      return role === '超级管理员' // 根据实际角色值调整
    },
    filteredGroups() {
      if (!this.appliedKeyword) return this.groupedData
      const kw = this.appliedKeyword.toLowerCase()
      return this.groupedData.filter(g =>
        (g.customerCode || '').toLowerCase().includes(kw) ||
        (g.customerName || '').toLowerCase().includes(kw)
      )
    }
  },
  mounted() {
    this.fetchList()

  },
  methods: {

    async fetchList() {
      this.loading = true
      try {
     
        const customerCode = window.localStorage.getItem('customerCode') || '401269638'
        const res = await api.getPaymentList({ customerCode})
      if (!res.success) {
        this.$message.error(res.errorMessage)
        return
      }
        this.allData = (res && res.success) && (Array.isArray(res.datalist) ? res.datalist : [])
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      this.appliedKeyword = this.searchKeyword
    },
    getContractTypeLabel(type) {
      return CONTRACT_TYPE_MAP[type] || type || ''
    },
    maskAccount(num) {
      if (!num) return ''
      const clean = String(num).replace(/\s/g, '')
      if (clean.length <= 8) return clean
      return clean.slice(0, 4) + ' **** **** ' + clean.slice(-4)
    },
    openAddDialog(group) {
      this.currentGroup = group
      this.isEdit = false
      this.dialogTitle = '新增银行账号'
      this.resetForm();
      this.dialogVisible = true
    },
    openEditDialog(group, payment) {
      this.currentGroup = group
      this.isEdit = true
      this.dialogTitle = '修改银行账号'
      this.form = { ...payment }
      this.dialogVisible = true
    },
    handleSubmit() {
      this.$refs.paymentForm.validate(async valid => {
        if (!valid) return
        this.submitting = true
        try {
          const param = { ...this.form, contractId: this.currentGroup.contractId,custNumber: this.currentGroup.customerCode }
      
          let res
          if (this.isEdit) {
            res =  await api.updatePayment(param)
          } else {
            res = await  api.addPayment(param)
          }
          if (!res.success) {
            this.$message.error(res.errorMessage)
            return
          }
          this.$message({ message: this.isEdit ? '修改成功' : '新增成功', type: 'success' })
          this.dialogVisible = false
          this.fetchList()
        } catch (e) {
          this.$message.error('操作失败')
        } finally {
          this.submitting = false
        }
      })
    },
    async handleDelete(payment) {
      try {
        await this.$confirm('此操作将永久删除该银行账号, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        await api.deletePayment(payment)
        this.$message({ message: '删除成功', type: 'success' })
        this.fetchList()
      } catch (e) {
        if (e !== 'cancel') {
          this.$message.error('删除失败')
        }
      }
    },
    resetForm() {
      this.form = { id: null, paymentType: '', payer: '', accountNumber: '', openingBank: '' }
      this.$nextTick(() => {
        this.$refs.paymentForm && this.$refs.paymentForm.resetFields()
      })
    }
  }
}
</script>

<style lang="less" scoped>
.customerPaymentManager {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .page-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 20px 24px 16px;
    border-bottom: 1px solid #f0f0f0;

    .header-info {
      .page-title {
        font-size: 16px;
        font-weight: 600;
        color: #333;
        margin-bottom: 4px;
        text-align: left;
      }
      .page-desc {
        font-size: 13px;
        color: #999;
      }
    }

    .header-search {
      display: flex;
      align-items: center;
    }
  }

  .card-grid {
    flex: 1;
    overflow-y: auto;
    padding: 0;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    align-content: start;

    &::-webkit-scrollbar {
      width: 6px;
    }
    &::-webkit-scrollbar-track {
      background-color: rgba(0, 0, 0, 0);
    }
    &::-webkit-scrollbar-thumb {
      background-color: rgba(0, 0, 0, 0.2);
      border-radius: 8px;
    }

    .empty-state {
      grid-column: 1 / -1;
      text-align: center;
      color: #999;
      padding: 60px 0;
      font-size: 14px;
    }
  }

  .contract-card {
    border: 1px solid #e8e8e8;
    border-radius: 8px;
    padding: 16px;
    background: #fff;
    transition: box-shadow 0.2s;
    margin: 15px;
    &:hover {
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
    }

    .contract-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 6px;

      .contract-code {
        font-size: 15px;
        font-weight: 600;
        color: #333;
      }

      .contract-tags {
        display: flex;
        gap: 4px;

        .tag-type {
          background-color: #f0f0f0;
          border-color: #f0f0f0;
          color: #666;
          margin-right: 15px;
        }
      }
    }

    .customer-name {
      font-size: 13px;
      color: #666;
      margin-bottom: 12px;
      text-align: left;
      i {
        margin-right: 4px;
        color: #999;
      }
    }

    .bank-section {
      border-top: 1px solid #f5f5f5;
      background: #f5f5f5;
      padding: 15px;
      .bank-section-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 13px;
        color: #666;
        margin-bottom: 8px;

        .add-link {
          color: #f56c6c;
          padding: 0;
          font-size: 13px;

          &:hover {
            color: #f78989;
          }
        }
      }

      .empty-bank {
        text-align: center;
        color: #bbb;
        font-size: 13px;
        padding: 16px 0;
        border: 1px dashed #e8e8e8;
        border-radius: 4px;
      }

      .bank-item {
        display: flex;
        align-items: center;
        padding: 10px 12px;
        border: 1px solid #ebebeb;
        // border-left: 3px solid #e8e8e8;
        border-radius: 6px;
        margin-bottom: 8px;
        // background: #fafafa;
        background: #fff;
        transition: border-left-color 0.2s, box-shadow 0.2s, background 0.2s;
        cursor: default;
        margin-top: 15px;
        &:last-child {
          margin-bottom: 0;
        }

        &:hover {
          border-color: #f56c6c;
          background: #fff;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);

          .bank-actions .action-icon {
            opacity: 1;
          }
        }

        .bank-icon-wrap {
          width: 34px;
          height: 34px;
          border-radius: 50%;
          background: #fff0f0;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          margin-right: 10px;

          .bank-icon {
            font-size: 18px;
            color: #f56c6c;
          }
        }

        .bank-info {
          flex: 1;
          overflow: hidden;

          .bank-name-num {
            font-size: 13px;
            font-weight: 500;
            color: #222;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            text-align: left;
            .account-num {
              font-family: 'Courier New', Courier, monospace;
              letter-spacing: 0.5px;
              color: #555;
              font-weight: 400;
              margin-left: 4px;
            }
          }

          .bank-payer {
            font-size: 12px;
            color: #aaa;
            margin-top: 3px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            text-align: left;
          }
        }

        .bank-actions {
          display: flex;
          gap: 12px;
          flex-shrink: 0;
          margin-left: 8px;

          .action-icon {
            font-size: 16px;
            color: #bbb;
            cursor: pointer;
            opacity: 0.8;
            transition: color 0.15s, opacity 0.15s;
            margin-right: 15px;
            color: rgb(226,51,30);

            &:hover {
              color: #409eff;
              opacity: 1;
            }

            &.delete-icon:hover {
              color: #f56c6c;
            }
          }
        }
      }
    }
  }
}
</style>
